import cn from 'classnames';
import { AudioIcon } from '../AnimatedIcons/AudioIcon/AudioIcon';
import { Text } from '../Text/Text';
import styles from './album.module.scss';
import { ReactNode } from 'react';

export interface AlbumProps {
    showInfoOnHover?: boolean;
    imageWidth: number | `${number}` | undefined;
    imageHeight: number | `${number}` | undefined;
    songTitle?: string;
    artist?: string;
    targetClass?: string;
    image?: ReactNode;
}

export default function Album({
    showInfoOnHover = false,
    imageWidth,
    imageHeight,
    songTitle,
    artist,
    targetClass,
    image,
}: AlbumProps): React.JSX.Element {
    const calcWrapperClasses = cn(styles.album, { [styles.albumHover]: showInfoOnHover });
    const calcHoverClasses = cn(styles.albumInfo, targetClass);

    return (
        <div className={calcWrapperClasses}>
            {image}
            <div className={calcHoverClasses} style={{ width: imageWidth, height: imageHeight }}>
                <AudioIcon targetClass={styles.audioIcon}></AudioIcon>
                <Text tag="p">{songTitle}</Text>
                <Text tag="p">{artist}</Text>
            </div>
        </div>
    );
}
